module.exports = __webpack_public_path__ + "media/alerta.7e195e56.mp3";